import { AnimatePresence, motion } from "framer-motion"
import type { ReactNode } from "react"
import { TRANSITION } from "@/shared/lib/motion"

const EASE = [0.4, 0, 0.2, 1] as const

/**
 * Блок, который появляется и пропадает посреди страницы: ошибка, предупреждение, панель,
 * лишнее поле. Высота раскрывается от нуля, поэтому то, что ниже, отъезжает плавно, а не
 * прыгает. Обрезка краёв только на время перехода, чтобы не резать обводку фокуса и тени.
 *
 * Отступ от соседей задавайте через `className` (это `padding` внутри), а не `margin`
 * снаружи: внешний отступ появился бы рывком.
 */
export function Reveal({
	show,
	children,
	className,
}: {
	show: boolean
	children: ReactNode
	className?: string
}) {
	return (
		<AnimatePresence initial={false}>
			{show ? (
				<motion.div
					key="reveal"
					initial={{ height: 0, opacity: 0, overflow: "clip" }}
					animate={{
						height: "auto",
						opacity: 1,
						transition: {
							height: { duration: TRANSITION.slow.duration, ease: EASE },
							opacity: { ...TRANSITION.swapIn, delay: 0.06 },
						},
						transitionEnd: { overflow: "visible" },
					}}
					exit={{
						height: 0,
						opacity: 0,
						overflow: "clip",
						pointerEvents: "none",
						transition: {
							height: { duration: TRANSITION.slow.duration, ease: EASE },
							opacity: TRANSITION.fast,
						},
					}}
				>
					<div className={className}>{children}</div>
				</motion.div>
			) : null}
		</AnimatePresence>
	)
}
